import { useReferrer } from 'hooks/useReferrer';
import ReactGA from 'react-ga4';

export const useGoogleAnalytics = () => {
    const { getInitialReferrer } = useReferrer();
    const sendPageViews = () => {
        const referrer = getInitialReferrer();
        const params = new URLSearchParams(window.location.search);
        const campaign = {
            source: params.get('utm_source'),
            medium: params.get('utm_medium'),
            campaign: params.get('utm_campaign')
        };
        ReactGA.send({
            hitType: 'pageview',
            page: window.location.pathname + window.location.search,
            campaign,
            page_referrer: referrer
        });
    };

    return { sendPageViews };
};
